import { render, staticRenderFns } from "./task-model-view-left-menu.vue?vue&type=template&id=41ba1a36&scoped=true&"
import script from "./task-model-view-left-menu.vue?vue&type=script&lang=ts&"
export * from "./task-model-view-left-menu.vue?vue&type=script&lang=ts&"
import style0 from "./task-model-view-left-menu.vue?vue&type=style&index=0&id=41ba1a36&prod&lang=less&scoped=true&"
import style1 from "./task-model-view-left-menu.vue?vue&type=style&index=1&id=41ba1a36&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba1a36",
  null
  
)

export default component.exports